"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var evilHardcodedSettings = _interopRequireWildcard(require("../mocks/settings"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = {
  settings: {
    mimeType: 'application/ld+json',
    corsEnabled: false
  },
  environments: {
    staging: 'https://settings.staging-api.immediate.co.uk',
    preproduction: 'https://settings.preproduction-api.immediate.co.uk',
    production: 'https://settings.api.immediate.co.uk'
  },
  endpoints: {
    clients: {
      endpoint: '/v1/settings/clients',
      // TODO: Remove once real data is being pushed to the settings API
      mocks: function mocks(originalFunctions) {
        return _objectSpread(_objectSpread({}, originalFunctions), {}, {
          get: function () {
            var _get = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id) {
              var _mockSettings$siteCon, _data$siteConfig;

              var data, mockSettings, mainNavigation;
              return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return originalFunctions.get(id);

                    case 2:
                      data = _context.sent;
                      mockSettings = evilHardcodedSettings[id];
                      mainNavigation = _objectSpread({}, data === null || data === void 0 ? void 0 : data.mainNavigation); // TODO: Remove this once work is complete to add wildcards via
                      // WP admin

                      if ((mockSettings === null || mockSettings === void 0 ? void 0 : mockSettings.site) === 'bbcgoodfood' || (mockSettings === null || mockSettings === void 0 ? void 0 : mockSettings.site) === 'historyextra') {
                        mainNavigation.menuItems[(mainNavigation === null || mainNavigation === void 0 ? void 0 : mainNavigation.menuItems.length) - 1].color = 2;
                        mainNavigation.menuItems[(mainNavigation === null || mainNavigation === void 0 ? void 0 : mainNavigation.menuItems.length) - 2].color = 1;
                      } // Hello future developer. This horrible thing was all supposed to be
                      // temporary. Sorry. Also, do you have hoverboards yet?


                      return _context.abrupt("return", _objectSpread(_objectSpread(_objectSpread({}, data), mockSettings), {}, {
                        mainNavigation: mainNavigation,
                        siteConfig: _objectSpread(_objectSpread({}, data === null || data === void 0 ? void 0 : data.siteConfig), {}, {
                          search: _objectSpread(_objectSpread({}, mockSettings === null || mockSettings === void 0 ? void 0 : (_mockSettings$siteCon = mockSettings.siteConfig) === null || _mockSettings$siteCon === void 0 ? void 0 : _mockSettings$siteCon.search), data === null || data === void 0 ? void 0 : (_data$siteConfig = data.siteConfig) === null || _data$siteConfig === void 0 ? void 0 : _data$siteConfig.search)
                        }),
                        // Find and replace in the web-bff etc., then remove this line.
                        cards: data === null || data === void 0 ? void 0 : data.cardSettings,
                        tracking: _objectSpread(_objectSpread({}, mockSettings === null || mockSettings === void 0 ? void 0 : mockSettings.tracking), data === null || data === void 0 ? void 0 : data.tracking),
                        posts: _objectSpread(_objectSpread({}, mockSettings === null || mockSettings === void 0 ? void 0 : mockSettings.posts), data === null || data === void 0 ? void 0 : data.posts),
                        header: _objectSpread(_objectSpread({}, mockSettings === null || mockSettings === void 0 ? void 0 : mockSettings.header), data === null || data === void 0 ? void 0 : data.header)
                      }));

                    case 7:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }));

            function get(_x) {
              return _get.apply(this, arguments);
            }

            return get;
          }()
        });
      }
    }
  }
};
exports["default"] = _default;